import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';

export const PlanDetailsWidgetWrapper = styled.div`
  flex: 1;
  padding: 20px;
  border: 1px solid ${COLORS.grey[400]};
  border-radius: 20px;
  background-image: linear-gradient(90deg, #eefffa 0%, #f1f5ff 52.67%, #fff4f9 100%);
`;

export const PlanLimitsDetailsWidgetWrapper = styled.div`
  ${flex({ flexDirection: 'column' })};
  row-gap: 6px;
  flex: 1;
  padding: 20px;
  border: 1px solid ${COLORS.grey[400]};
  border-radius: 20px;
  background-color: ${COLORS.white};
`;

export const CardDetailsWrapper = styled.div`
  width: 364px;
  background-color: ${COLORS.white};
  border-radius: 20px;
  border: 1px solid ${COLORS.grey[300]};
  box-shadow: 0 12px 24px 0 rgb(62 65 86 / 15%);
  height: max-content;
  padding: 26px 20px;
  flex-grow: 1;

  ${media.mobile`
    width: 100%;
  `}
`;
